const apiPaths = {
  promotionPricingAll: '/groups/forever-print-artisan-products/primary_promotion',
  group: '/groups/:slug/marketing',
  groupPromotions: '/groups/:slug/primary_promotion',

  //cart
  lineItems: '/line_items',
  orderAdjustments: '/order_adjustments' //post to add a promotion code
};

export function usePricingApi() {
  return {
    async getPromotionPricing() {
      const data = await useStoreApi().fetch(apiPaths.promotionPricingAll);
      const promotions  = data.group?.products;

      return promotions?.filter(item => item.primary_promotion && Object.keys(item.primary_promotion).length);
    },

    async getGroupProducts({groupSlug, includeDescriptions = false}) {
      const data = await useStoreApi().fetch(apiPaths.group, {
        params: {
          route: {slug: groupSlug},
          ...(includeDescriptions
            ? {query: {include_descriptions: true}}
            : {})
        }
      });
      return data.group?.products;
    },

    async getGroupPromotions({groupSlug}) {
      const data = await useStoreApi().fetch(apiPaths.groupPromotions, {
        params: {
          route: {slug: groupSlug}
        }
      });
      return data.group?.products;
    },

    async addToCart({productId, quantity = 1, optionValues = [], requiredLineItemsAttributes = [], promotionCode, additionalAttributes = {}, gift}) {
      const payload = {
        product_id: productId,
        quantity,
        line_item_option_values_attributes: optionValues,
        required_line_items_attributes: requiredLineItemsAttributes,
        gift,
        ...additionalAttributes
      };

      const response = await useStoreApi().post(apiPaths.lineItems, {
        body: payload
      });

      if (promotionCode) {
        try {
          await useStoreApi().post(apiPaths.orderAdjustments, {
            body: {code: promotionCode}
          });
        } catch {
          //
        }
      }

      return response;
    }
  }
}

